import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;
const methodUrl = `${apiUrl}employees`;

export const getAdministrators = () => axios.get(`${methodUrl}/administrators`);
export const getHR = () => axios.get(`${methodUrl}/HR`);
export const getSupervisors = () => axios.get(`${methodUrl}/supervisors`);
export const getAccountManagers = () => axios.get(`${methodUrl}/accountManagers`);
export const getHelpers = () => axios.get(`${methodUrl}/Helpers`);
export const getMerchandisers = () => axios.get(`${methodUrl}/merchandisers`);

export const getEmployees = (
  storeId,
  distance,
  provinceId,
  cityIds,
  isReside,
  isTravel,
  commodityIds,
  retailerIds,
  minimumAvailability,
  startDate,
  endDate,
  supervisorIds,
  name
) => {
  const params = [];
  storeId = storeId ? `storeId=${storeId}` : null;
  distance = distance ? `distance=${distance}` : null;
  provinceId = provinceId ? `provinceId=${provinceId}` : null;
  cityIds = cityIds ? `cityIds=${cityIds}` : null;
  isReside = isReside ? `isReside=${isReside}` : null;
  isTravel = isTravel ? `isTravel=${isTravel}` : null;
  commodityIds = commodityIds ? `commodityIds=${commodityIds}` : null;
  retailerIds = retailerIds ? `retailerIds=${retailerIds}` : null;
  minimumAvailability = minimumAvailability
    ? `minimumAvailability=${minimumAvailability}`
    : null;
  startDate = startDate ? `startDate=${startDate}` : null;
  endDate = endDate ? `endDate=${endDate}` : null;
  supervisorIds = supervisorIds ? `supervisorIds=${supervisorIds}` : null;
  name = name ? `name=${name}` : null;
  if (storeId !== null) params.push(storeId);
  if (distance !== null) params.push(distance);
  if (provinceId !== null) params.push(provinceId);
  if (cityIds !== null) params.push(cityIds);
  if (isReside !== null) params.push(isReside);
  if (isTravel !== null) params.push(isTravel);
  if (commodityIds !== null) params.push(commodityIds);
  if (retailerIds !== null) params.push(retailerIds);
  if (minimumAvailability !== null) params.push(minimumAvailability);
  if (startDate !== null) params.push(startDate);
  if (endDate !== null) params.push(endDate);
  if (name !== null) params.push(name);
  if (supervisorIds !== null) params.push(supervisorIds);
  const query = params.length > 0 ? `?${params.join("&")}` : "";
  return axios.get(`${methodUrl}/search${query}`);
};

export const getEmployeeAvailability = id =>
  axios.get(`${methodUrl}/${id}/availability`);

export const getEmployeeScheduledWork = id =>
  axios.get(`${methodUrl}/${id}/scheduledWork`);
